import { Typography } from '@mui/material'
import React from 'react'

interface Props {
  error: string | undefined
  visible: boolean | undefined
}

const ErrorMessage: React.FC<Props> = ({ error, visible }) => {
  if (error === undefined || visible === false || visible === undefined) return null

  return (
    <Typography color='error' sx={{ mt: 0.5 }} variant='body2'>
      {error}
    </Typography>
  )
}

export default ErrorMessage
